import { useAuth, useUsersMap } from "@tellescope/tanstack-query";
import { Label, MultiSelect, PageTabsContent } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { EditUserForm } from "./useEditUserForm";
import { formatPhone } from "@tellescope/utils";
import { useMemo } from "react";

export interface PhoneTabContentProps {
  form: EditUserForm;
}

export const PhoneTabContent = ({ form }: PhoneTabContentProps) => {
  const { t } = useTranslation("settings");
  const { selectedOrganization } = useAuth();
  const usersMap = useUsersMap();

  const phoneNumberOptions = useMemo(() => {
    const set = new Set<string>(selectedOrganization?.twilioNumber ? [selectedOrganization.twilioNumber] : []);
    selectedOrganization?.twilioNumbers?.forEach((number) => {
      if (number) set.add(number);
    });
    Object.values(usersMap).forEach((user) => {
      if (user.twilioNumber) set.add(user.twilioNumber);
    });
    return Array.from(set).map((number) => ({
      value: number,
      label: `${selectedOrganization?.phoneLabels?.find(({ number: n }) => number === n)?.label ?? ""} ${formatPhone(
        number
      )}`.trim(),
    }));
  }, [
    selectedOrganization?.phoneLabels,
    selectedOrganization?.twilioNumber,
    selectedOrganization?.twilioNumbers,
    usersMap,
  ]);

  return (
    <PageTabsContent
      value="phone"
      className="px-6 py-4 space-y-4 overflow-y-auto"
      style={{
        maxHeight: "min(80vh, 900px)",
      }}
    >
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="availableFromNumbers">{t("Available Phone Numbers")}</Label>
          <MultiSelect
            id="availableFromNumbers"
            options={phoneNumberOptions}
            {...form.getCustomFieldProps("availableFromNumbers")}
            placeholder={t("Leave blank for default")}
            searchPlaceholder={t("Search phone numbers...")}
            emptyText={t("No phone numbers found")}
          />
        </div>
      </div>
    </PageTabsContent>
  );
};
